import { SidekickSupportedTms } from '@shared/generated/graphql';
import { SupportedEntityType, TMSPageInfo } from './types';

export function getLegacyMercuryGatePageInfo(dom: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.LEGACY_MERCURYGATE,
    entityInfo: getEntityInfo(dom),
  };
}

const getEntityInfo = (dom: string) => {
  const shipmentPattern: RegExp =
    /<span[^>]*class=["']rhd-primary-ref clickable["'][^>]*>(LD[0-9A-Z]+)<\/span>/;
  const shipmentMatch: RegExpMatchArray | null = dom.match(shipmentPattern);

  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
};
